
export interface ITellerOperation {
    id: number,
    isArticle: boolean,

    registrationId: number,
    
    amount: number,
    operationDate: Date,
    issueDate: Date,
    bearer: string,
    reference: string,
    isCancelled: boolean,
    cancellationDate: Date,
    cancellationPurpose: string,
    isCancelledAtDayClosing: boolean,
    tellerDayClosingId: number,

    tellerOperationBillings: ITellerOperationBilling[],
    tellerOperationModes: ITellerOperationMode[],


    firstName: string,
    lastName: string,
    schoolYearName: string,
    schoolYearClassName: string,
    registrationCode: string,

    // This for importation....
    operationDateInput: string,

    operationBillingCode1: string,
    operationBillingAmount1: number,	
    operationBillingCode2: string,
    operationBillingAmount2: number,
    operationBillingCode3: string,	
    operationBillingAmount3: number,	
    operationBillingCode4: string,	
    operationBillingAmount4: number,	
    operationBillingCode5: string,	
    operationBillingAmount5: number,	
    
    operationModeCode1: string,	
    operationModeAmount1: number,	
    operationModeReference1: string,	
    operationModeOperatorCode1: string,	
    operationModePhoneNumber1: string,	
    operationModeTransferToAccountNumber1: string,	

    operationModeCode2: string,
    operationModeAmount2: number,	
    operationModeReference2: string,	
    operationModeOperatorCode2: string,	
    operationModePhoneNumber2: string,	
    operationModeTransferToAccountNumber2: string,

    operationModeCode3: string,	
    operationModeAmount3: number,
    operationModeReference3: string,	
    operationModeOperatorCode3: string,	
    operationModePhoneNumber3: string,	
    operationModeTransferToAccountNumber3: string,
  }

  export interface ITellerOperationBilling {
    id: number,
    tellerOperationId: number,

    billingId: number,   
    amount: number,

    billingTypeId: number,
    parentBillingTypeId: number,

    billingTypeName: string,
    billingAmount: number,
    amountPaid: number,
    dueAmount: number,
    unpaidAmount: number,
  }

  export interface ITellerOperationMode {
    id: number,
    tellerOperationId: number,
 
    amount: number,
    reference: string,

    type: string,

    checkBankCode: string,
    checkNumber: string,
    checkDate: Date,
    operatorCode: string,
    phoneNumber: string,
    cartType: string,
    cartNumber: string,
    transferFromBankCode: string,
    transferFromToCode: string,
    transferFromAccountNumber: string,
    transferToAccountNumber: string,
    otherReference: string,
    
    paymentOperationId: number,
  }


  export const defaultTellerOperation : ITellerOperation = {
    id: 0,
    isArticle: false,
    registrationId: 0,
    amount: 0,
    operationDate: new Date(),
    issueDate: new Date(),
    bearer: '',
    reference: '',
    isCancelled: false,
    
    cancellationDate: new Date(),
    cancellationPurpose: '',

    isCancelledAtDayClosing: false,
    tellerDayClosingId: 0,

    tellerOperationBillings: [],
    tellerOperationModes: [],

    firstName: '',
    lastName: '',
    schoolYearName: '',
    schoolYearClassName: '',

    registrationCode: '',


    operationDateInput: '',

    operationBillingCode1: '',
    operationBillingAmount1: 0,	
    operationBillingCode2: '',
    operationBillingAmount2: 0,
    operationBillingCode3: '',	
    operationBillingAmount3: 0,	
    operationBillingCode4: '',	
    operationBillingAmount4: 0,	
    operationBillingCode5: '',	
    operationBillingAmount5: 0,	
    
    operationModeCode1: '',	
    operationModeAmount1: 0,	
    operationModeReference1: '',	
    operationModeOperatorCode1: '',	
    operationModePhoneNumber1: '',	
    operationModeTransferToAccountNumber1: '',

    operationModeCode2: '',
    operationModeAmount2: 0,	
    operationModeReference2: '',	
    operationModeOperatorCode2: '',	
    operationModePhoneNumber2: '',	
    operationModeTransferToAccountNumber2: '',

    operationModeCode3: '',	
    operationModeAmount3: 0,
    operationModeReference3: '',	
    operationModeOperatorCode3: '',	
    operationModePhoneNumber3: '',	
    operationModeTransferToAccountNumber3: '',
  }

  export const defaultTellerOperationEx = {...defaultTellerOperation, isArticle: true}


  export const defaultTellerOperationMode : ITellerOperationMode = {
    id: 0,
    tellerOperationId: 0,
 
    amount: 0,
    reference: '',

    type: '',

    checkBankCode: '',
    checkNumber: '',
    checkDate: new Date(),
    operatorCode: '',
    phoneNumber: '',
    cartType: '',
    cartNumber: '',
    transferFromBankCode: '',
    transferFromToCode: '',
    transferFromAccountNumber: '',
    transferToAccountNumber: '',
    otherReference: '',
    
    paymentOperationId: 0,
  }


  export interface ITellerOperationDashboard {
    
    amount: number,
    netAmountAtDayClosing: number,
    netAmount: number,

    cancelledAmount: number,
    cancelledAmountAtDayClosing: number,
    cancelledAmountAfterClosing: number,

    count: number,
    countNetAtDayClosing: number,
    countNet: number,

    countCancelled: number,
    countCancelledAtDayClosing: number,
    countCancelledAfterClosing: number,

    operationsByClass : IOperationDasbordItem[],
    operationsByTeller : IOperationDasbordItem[]
    operationsByBillingType : IOperationDasbordItem[]
    operationsByBillingCategory : IOperationDasbordItem[],
    operationsByMode: IOperationDasbordItem[],
  }

  export interface IOperationDasbordItem {
    id: number,
    name: string, 
    totalAmount: number, 
    amount: number, 
    count: number, 
    netAmount: number, 
    netAmountAtClosingDay: number, 
    cancelledAmount: number
  }

  export const defaultTellerOperationDashboard : ITellerOperationDashboard = {
    amount: 0,
    netAmountAtDayClosing: 0,
    netAmount: 0,

    cancelledAmount: 0,
    cancelledAmountAtDayClosing: 0,
    cancelledAmountAfterClosing: 0,

    count: 0,
    countNetAtDayClosing: 0,
    countNet: 0,

    countCancelled: 0,
    countCancelledAtDayClosing: 0,
    countCancelledAfterClosing: 0,

    operationsByClass:[],
    operationsByTeller : [],
    operationsByBillingType : [],
    operationsByBillingCategory : [],
    operationsByMode: [],
  }


  export interface ITellerOperationSearch {
    schoolYearId: number,
        
    schoolYearClassName: string,

    firstName: string,
    lastName: string,

    reference: string,
    bearer: string
  }